export const servicesPages = [
  {
    slug: "refection-toiture-94",
    footerLabel: "Réfection toiture 94",
    metaTitle: "Réfection toiture 94 — MSC Toitures | Refaire sa toiture dans le Val-de-Marne",
    metaDescription:
      "Réfection de toiture dans le Val-de-Marne (94) : remplacement de couverture, liteaux, écran de sous-toiture, zinguerie. MSC Toitures, Champigny-sur-Marne. Devis gratuit.",
    overline: "Réfection de couverture — Val-de-Marne",
    h1: "Réfection de toiture dans le 94 : refaire votre couverture dans les règles de l'art",
    intro: [
      "La réfection de toiture consiste à refaire tout ou partie de votre couverture : dépose de l'ancienne toiture, contrôle de la charpente, pose d'un écran de sous-toiture, liteaunage neuf, nouvelle couverture et zinguerie associée. C'est le chantier le plus complet après la construction — et celui qui donne à votre maison une protection durable pour des décennies.",
      "Chez MSC Toitures, basée à Champigny-sur-Marne, la réfection commence toujours par un diagnostic gratuit sur place : nous vérifions l'état réel de la couverture et de la charpente avant de vous proposer un devis détaillé, partout dans le Val-de-Marne.",
    ],
    blocks: [
      {
        h2: "Réfection ou rénovation : quelle différence ?",
        paragraphs: [
          "On parle de rénovation lorsque la structure est saine et que l'intervention porte sur des éléments ciblés : un versant, le faitage, la zinguerie. La réfection va plus loin : on redépose la couverture pour repartir sur des bases entièrement neuves — liteaux, écran de sous-toiture, tuiles ou ardoises, noues et rives.",
          "Lors du diagnostic, nous vous disons franchement dans quelle situation se trouve votre toiture. Si une rénovation suffit, nous ne vous pousserons pas vers une réfection — et inversement, si la couverture est en fin de vie, nous vous expliquons pourquoi des réparations répétées finiraient par coûter plus cher.",
        ],
      },
      {
        h2: "Les signes qu'une réfection s'impose",
        paragraphs: [
          "Certains signaux indiquent qu'une toiture est arrivée au bout de sa vie utile.",
        ],
        list: [
          "Fuites à répétition malgré les réparations successives",
          "Tuiles poreuses, effritées ou voilées sur l'ensemble des versants",
          "Liteaux ou voliges fatigués, constatés lors de précédentes interventions",
          "Mousse et lichen incrustés qui reviennent malgré les démoussages",
          "Toiture de plusieurs décennies jamais refaite",
        ],
      },
      {
        h2: "Comment se déroule une réfection MSC Toitures",
        paragraphs: [
          "Après le diagnostic et le devis gratuit, le chantier suit des étapes claires : protection des abords, dépose de l'ancienne couverture, vérification de la charpente, pose de l'écran de sous-toiture et des liteaux, couverture neuve, puis zinguerie et finitions. La maison reste protégée pendant toute la durée des travaux.",
          "Vous pouvez voir des exemples de réfections en cours et terminées dans notre galerie de réalisations, dont une réfection de toiture menée à Saint-Maur-des-Fossés.",
        ],
      },
    ],
    ctaTitle: "Un projet de réfection de toiture dans le 94 ?",
    photo: "/photos/refection-termine.webp",
    photoAlt: "Toiture en tuiles terminée avec velux après réfection par MSC Toitures",
    linksBlock: {
      title: "Nos autres prestations de couverture",
      links: [
        { to: "/renovation-toiture-94", label: "Rénovation de toiture 94" },
        { to: "/reparation-toiture-94", label: "Réparation de toiture 94" },
        { to: "/charpente-94", label: "Travaux de charpente 94" },
        { to: "/couvreur-94", label: "Couvreur dans le Val-de-Marne" },
      ],
    },
  },
  {
    slug: "gouttiere-94",
    footerLabel: "Gouttière 94",
    metaTitle: "Réparation gouttière 94 — MSC Toitures | Gouttières & descentes Val-de-Marne",
    metaDescription:
      "Réparation et remplacement de gouttières dans le Val-de-Marne (94) : gouttière qui fuit, déborde ou se déforme. MSC Toitures, Champigny-sur-Marne. Devis gratuit.",
    overline: "Gouttières & évacuation des eaux — Val-de-Marne",
    h1: "Réparation de gouttières dans le 94 : protégez vos façades de l'eau",
    intro: [
      "Une gouttière qui déborde, fuit aux joints ou s'affaisse ne est pas qu'un désagrément : l'eau qui ruisselle le long des murs tache les façades, fragilise les fondations et finit parfois par s'infiltrer sous la couverture. MSC Toitures répare et remplace gouttières, descentes et chéneaux dans tout le Val-de-Marne.",
      "Basés à Champigny-sur-Marne, nous nous déplaçons gratuitement pour constater l'état de votre évacuation des eaux pluviales et vous remettre un devis gratuit.",
    ],
    blocks: [
      {
        h2: "Les signes d'une gouttière en souffrance",
        paragraphs: [
          "Quelques signes simples à observer depuis le sol, notamment les jours de pluie.",
        ],
        list: [
          "Débordement dès une pluie modérée, souvent signe d'obstruction ou de pente insuffisante",
          "Joints qui gouttent ou sections disjointes",
          "Gouttière qui s'affaisse entre deux crochets ou se déforme",
          "Traces d'humidité ou mousses sur la façade sous la gouttière",
          "Descente bouchée ou qui laisse couler l'eau le long du mur",
        ],
      },
      {
        h2: "Réparer ou remplacer ?",
        paragraphs: [
          "Tout dépend de l'état général : un joint à refaire, une section à ressouder ou une pente à corriger relèvent d'une réparation simple. En revanche, une gouttière corrodée sur toute sa longueur ou mal dimensionnée pour la surface du toit mérite un remplacement.",
          "Lors de notre visite — gratuite — nous inspectons l'ensemble du linéaire et des descentes, et nous vous proposons la solution la plus juste : jamais plus que nécessaire.",
        ],
      },
      {
        h2: "Des gouttières adaptées à votre toiture",
        paragraphs: [
          "Profil, section, matériau, nombre de descentes : une gouttière se dimensionne en fonction de la surface de toiture qu'elle collecte. Nous posons et refaçonnons des éléments adaptés à votre maison, avec des pentes correctes et des fixations solides, pour une évacuation durable des eaux pluviales.",
        ],
      },
    ],
    ctaTitle: "Gouttière abîmée dans le 94 ? Appelez-nous",
    photo: "/photos/zinguerie-apres.webp",
    photoAlt: "Toiture en zinc après travaux de zinguerie et gouttières par MSC Toitures",
    linksBlock: {
      title: "Voir aussi",
      links: [
        { to: "/zinguerie-94", label: "Travaux de zinguerie 94" },
        { to: "/fuite-toiture-94", label: "Fuite de toiture 94" },
        { to: "/entretien-toiture-94", label: "Entretien de toiture 94" },
        { to: "/couvreur-94", label: "Couvreur dans le Val-de-Marne" },
      ],
    },
  },
  {
    slug: "demoussage-toiture-94",
    footerLabel: "Démoussage toiture 94",
    metaTitle: "Démoussage toiture 94 — MSC Toitures | Nettoyage de toiture Val-de-Marne",
    metaDescription:
      "Démoussage et nettoyage de toiture dans le Val-de-Marne (94) : mousse, lichen, tuiles poreuses. MSC Toitures, Champigny-sur-Marne. Déplacement et devis gratuits.",
    overline: "Nettoyage & démoussage — Val-de-Marne",
    h1: "Démoussage de toiture dans le 94 : redonnez de l'éclat à vos tuiles",
    intro: [
      "Mousse verte sur les versants nord, lichen incrusté, tuiles noircies : dans le Val-de-Marne, l'humidité et les arbres des jardins pavillonnaires accélèrent l'encrassement des toitures. Au-delà de l'aspect esthétique, la mousse retient l'eau, rend les tuiles poreuses et peut soulever les éléments de couverture.",
      "MSC Toitures réalise le nettoyage et le démoussage de votre toiture dans tout le 94, avec un déplacement et un devis gratuits.",
    ],
    blocks: [
      {
        h2: "Pourquoi démousser sa toiture ?",
        paragraphs: [
          "La mousse agit comme une éponge : elle garde l'humidité au contact des tuiles en permanence. Avec les cycles de gel et de dégel, les tuiles deviennent poreuses, se fissurent, puis laissent passer l'eau. Un démoussage régulier prolonge nettement la durée de vie de la couverture.",
          "C'est aussi l'occasion de dégager les gouttières et les points singuliers (noues, chéneaux, abergements) où les débris s'accumulent et provoquent des débordements.",
        ],
      },
      {
        h2: "Quand prévoir un démoussage ?",
        paragraphs: [
          "Il n'y a pas de règle absolue : tout dépend de l'exposition de votre toiture, de la présence d'arbres à proximité et de l'âge de la couverture. Les versants exposés au nord et les toitures ombragées s'encrassent plus vite. Un bon indicateur : dès que la mousse forme un tapis visible depuis le sol, il est temps d'intervenir.",
          "Lors de notre passage — déplacement gratuit — nous vous indiquons honnêtement si un démoussage est utile ou s'il peut attendre.",
        ],
      },
      {
        h2: "Un nettoyage adapté à votre couverture",
        paragraphs: [
          "Chaque couverture a ses contraintes : tuiles anciennes fragiles, ardoises, fibro... Nous adaptons la méthode de nettoyage au matériau pour préserver l'intégrité de la toiture, puis nous vérifions l'état des tuiles et de la zinguerie au passage — un défaut repéré tôt coûte toujours moins cher à réparer.",
        ],
      },
    ],
    ctaTitle: "Votre toiture verdit ? Demandez un diagnostic gratuit",
    photo: "/photos/chantier.webp",
    photoAlt: "Chantier d'entretien de toiture MSC Toitures avec échafaudage dans le Val-de-Marne",
    linksBlock: {
      title: "Voir aussi",
      links: [
        { to: "/entretien-toiture-94", label: "Entretien de toiture 94" },
        { to: "/reparation-toiture-94", label: "Réparation de toiture 94" },
        { to: "/gouttiere-94", label: "Réparation de gouttières 94" },
        { to: "/couvreur-94", label: "Couvreur dans le Val-de-Marne" },
      ],
    },
  },
  {
    slug: "entretien-toiture-94",
    footerLabel: "Entretien toiture 94",
    metaTitle: "Entretien toiture 94 — MSC Toitures | Entretenir sa toiture dans le Val-de-Marne",
    metaDescription:
      "Entretien de toiture dans le Val-de-Marne (94) : inspection, nettoyage, petites réparations préventives. MSC Toitures, Champigny-sur-Marne. Devis gratuit.",
    overline: "Entretien préventif — Val-de-Marne",
    h1: "Entretien de toiture dans le 94 : prévenir plutôt que réparer",
    intro: [
      "Une toiture s'entretient comme une chaudière : un contrôle régulier permet de repérer les petits défauts — tuile fêlée, joint de gouttière fatigué, mousse naissante — avant qu'ils ne se transforment en fuite ou en gros chantier. C'est la démarche la plus économique sur la durée de vie d'une maison.",
      "MSC Toitures propose l'entretien de votre toiture dans tout le Val-de-Marne, avec un déplacement gratuit et un compte rendu clair de ce que nous constatons.",
    ],
    blocks: [
      {
        h2: "Ce que comprend une visite d'entretien",
        paragraphs: [
          "Lors d'une visite d'entretien, nous montons sur la toiture et inspectons méthodiquement l'ensemble des points sensibles.",
        ],
        list: [
          "État des tuiles ou ardoises : fêlures, déplacements, porosité",
          "Faitage, arêtiers et rives",
          "Gouttières, chéneaux, noues et descentes",
          "Abergements de cheminée et contours de velux",
          "Présence de mousse, lichen ou accumulations de débris",
        ],
      },
      {
        h2: "L'entretien, l'allié de votre portefeuille",
        paragraphs: [
          "Une tuile remplacée à temps ou un joint de gouttière refait coûte peu. La même négligence, deux ans plus tard, peut signifier une charpente humide, un isolant à changer et un plafond à refaire. L'entretien préventif est toujours l'option la moins chère.",
          "Après chaque visite, nous vous remettons un état clair de la toiture : ce qui est en bon état, ce qui mérite une surveillance, et ce qui doit être réparé — avec un devis gratuit si des travaux sont nécessaires.",
        ],
      },
      {
        h2: "Un interlocuteur local pour suivre votre toiture",
        paragraphs: [
          "Basés à Champigny-sur-Marne, avec un showroom au 34 boulevard de Polangis, nous restons disponibles entre les visites : une question après une tempête, un doute sur une tuile, un appel suffit. Vous parlez directement à l'entreprise qui intervient chez vous.",
        ],
      },
    ],
    ctaTitle: "Planifiez l'entretien de votre toiture",
    photo: "/photos/equipe.webp",
    photoAlt: "Couvreur MSC Toitures inspectant une toiture dans le Val-de-Marne",
    linksBlock: {
      title: "Voir aussi",
      links: [
        { to: "/demoussage-toiture-94", label: "Démoussage de toiture 94" },
        { to: "/fuite-toiture-94", label: "Fuite de toiture 94" },
        { to: "/gouttiere-94", label: "Réparation de gouttières 94" },
        { to: "/couvreur-94", label: "Couvreur dans le Val-de-Marne" },
      ],
    },
  },
  {
    slug: "charpente-94",
    footerLabel: "Charpente 94",
    metaTitle: "Charpente 94 — MSC Toitures | Contrôle & réparation de charpente Val-de-Marne",
    metaDescription:
      "Travaux de charpente dans le Val-de-Marne (94) : contrôle lors des diagnostics toiture, réparations localisées, bois humides. MSC Toitures, Champigny-sur-Marne. Devis gratuit.",
    overline: "Charpente — Val-de-Marne",
    h1: "Charpente dans le 94 : la structure qui porte votre toiture",
    intro: [
      "La charpente est le squelette de votre toiture : tant qu'elle est saine, tout va bien ; dès qu'elle souffre — humidité, affaissement, bois fragilisés — c'est toute la couverture qui est menacée. À Champigny-sur-Marne et dans tout le Val-de-Marne, MSC Toitures accorde à la charpente une attention particulière à chaque intervention.",
      "Lors de nos diagnostics — gratuits — nous inspectons systématiquement la charpente visible depuis les combles et lors de la dépose éventuelle de la couverture, avant toute réfection.",
    ],
    blocks: [
      {
        h2: "Les signes d'une charpente fragilisée",
        paragraphs: [
          "Quelques signaux doivent vous amener à faire contrôler votre charpente.",
        ],
        list: [
          "Affaissement ou ondulation visible d'un versant de toiture",
          "Bois humides, noircis ou friables dans les combles",
          "Fuite ancienne ou chronique au-dessus de la charpente",
          "Trous de sortie d'insectes xylophages dans les bois",
          "Odeur d'humidité persistante sous le toit",
        ],
      },
      {
        h2: "Réparations localisées de charpente",
        paragraphs: [
          "Une charpente abîmée ne signifie pas forcément une charpente à refaire entièrement. Lorsque les dégâts sont localisés — quelques chevrons, une section de panne, des bois attaqués par l'humidité d'une fuite — une réparation ciblée suffit souvent à redonner à la structure sa solidité.",
          "Nous vous présentons l'état réel de la charpente, photos à l'appui, et la solution la plus juste : réparation localisée quand c'est possible, et un avis honnête quand le mal est plus profond.",
        ],
      },
      {
        h2: "Charpente et couverture : un ensemble indissociable",
        paragraphs: [
          "C'est lors des travaux de couverture que la charpente se révèle : dépose d'une toiture pour réfection, recherche de fuite, remplacement de liteaux... Notre approche de couvreur intègre toujours ce regard sur la structure. Si vous envisagez une réfection de toiture, c'est le moment idéal pour un contrôle complet de la charpente.",
        ],
      },
    ],
    ctaTitle: "Un doute sur votre charpente ? Faites-la contrôler",
    photo: "/photos/refection-pendant.webp",
    photoAlt: "Charpente, liteaux et écran de sous-toiture lors d'une réfection MSC Toitures",
    linksBlock: {
      title: "Voir aussi",
      links: [
        { to: "/refection-toiture-94", label: "Réfection de toiture 94" },
        { to: "/renovation-toiture-94", label: "Rénovation de toiture 94" },
        { to: "/fuite-toiture-94", label: "Fuite de toiture 94" },
        { to: "/couvreur-94", label: "Couvreur dans le Val-de-Marne" },
      ],
    },
  },
  {
    slug: "etancheite-toiture-94",
    footerLabel: "Étanchéité toiture 94",
    metaTitle: "Étanchéité toiture 94 — MSC Toitures | Étanchéité & points singuliers Val-de-Marne",
    metaDescription:
      "Travaux d'étanchéité de toiture dans le Val-de-Marne (94) : toits-terrasses, relevés d'étanchéité, points singuliers, raccords. MSC Toitures, Champigny-sur-Marne. Devis gratuit.",
    overline: "Étanchéité — Val-de-Marne",
    h1: "Étanchéité de toiture dans le 94 : les détails qui gardent l'eau dehors",
    intro: [
      "L'étanchéité d'une toiture ne se joue pas seulement sur les tuiles : elle se gagne sur les points singuliers — raccords de cheminée, contours de velux, relevés contre les murs, acrotères, toits-terrasses. Ce sont ces zones qui concentrent la majorité des infiltrations.",
      "MSC Toitures réalise les travaux d'étanchéité de toiture dans tout le Val-de-Marne : reprise de points singuliers, membranes, relevés et raccords. Déplacement et devis gratuits.",
    ],
    blocks: [
      {
        h2: "Les points singuliers, premiers responsables des fuites",
        paragraphs: [
          "Une cheminée qui traverse le toit, un velux, une souche de ventilation, un mur mitoyen : chaque élément qui perce ou rejoint la couverture crée une zone de raccord vulnérable. Quand les solins, les abergements ou les relevés d'étanchéité vieillissent, l'eau trouve le passage.",
          "C'est pourquoi une recherche de fuite sérieuse commence toujours par l'examen de ces points singuliers avant de soupçonner la couverture elle-même.",
        ],
      },
      {
        h2: "Reprise d'étanchéité : comment nous intervenons",
        paragraphs: [
          "Selon la configuration — toiture inclinée, toit-terrasse, acrotère — la reprise d'étanchéité consiste à refaire les relevés, remplacer les membranes fatiguées, refaçonner les solins et abergements en zinc, et vérifier les raccords. L'objectif : une barrière continue contre l'eau, durable et propre visuellement.",
          "Chaque intervention débute par un diagnostic gratuit sur place : nous identifions précisément la zone défaillante avant de chiffrer la reprise.",
        ],
      },
      {
        h2: "Étanchéité et zinguerie : un même savoir-faire",
        paragraphs: [
          "Sur une toiture, l'étanchéité et la zinguerie travaillent main dans la main : les abergements, solins, noues et chéneaux en zinc assurent à la fois la jonction et l'évacuation de l'eau. Nos travaux d'étanchéité s'appuient sur cette double compétence de couvreur-zingueur.",
        ],
      },
    ],
    ctaTitle: "Un problème d'étanchéité ? Parlons-en",
    photo: "/photos/zinguerie-apres.webp",
    photoAlt: "Toiture en zinc étanche après travaux d'étanchéité par MSC Toitures",
    linksBlock: {
      title: "Voir aussi",
      links: [
        { to: "/zinguerie-94", label: "Travaux de zinguerie 94" },
        { to: "/fuite-toiture-94", label: "Fuite de toiture 94" },
        { to: "/reparation-toiture-94", label: "Réparation de toiture 94" },
        { to: "/couvreur-94", label: "Couvreur dans le Val-de-Marne" },
      ],
    },
  },
];
